export default {
  TableHeadMember: [
    [
      {
        displayName: 'report.winloseSimple.datatable.number',
        attr: {
          rowspan: 2,
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.username',
        attr: {
          rowspan: 2,
          class: 'text-left',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.nickname',
        attr: {
          rowspan: 2,
          class: 'text-left',
        },
        levelOne: true,
      },
      {
        displayName: 'report.winloseSimple.datatable.turnover',
        attr: {
          rowspan: 2,
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.stake',
        attr: {
          rowspan: 2,
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.commission',
        attr: {
          rowspan: 2,
          class: 'text-right',
        },
      },
      // {
      //   displayName: 'report.winloseSimple.datatable.bonusAmount',
      //   attr: {
      //     rowspan: 2,
      //     class: 'text-right',
      //   },
      // },
      {
        displayName: 'report.winloseSimple.datatable.member100',
        attr: {
          rowspan: 2,
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.member',
        attr: {
          colspan: 3,
        },
        isCompanyHidden: true,
      },
      {
        displayName: 'report.winloseSimple.datatable.agent',
        attr: {
          colspan: 3,
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.company',
        attr: {
          colspan: 3,
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.api',
        attr: {
          colspan: 3,
        },
        isAnyHidden: true,
      },
    ],
    [
      {
        displayName: 'report.winloseSimple.datatable.winlose',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.commission',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.total',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.winlose',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.commission',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.total',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.winlose',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.commission',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.total',
        attr: {
          class: 'text-right',
        },
      },
    ],
  ],
  TableHeadLog: [
    [
      {
        displayName: 'report.winloseSimple.datatable.number',
        attr: {
          rowspan: 2,
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.info',
        attr: {
          rowspan: 2,
          class: 'text-left',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.activity',
        attr: {
          rowspan: 2,
          class: 'text-left',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.amount',
        attr: {
          rowspan: 2,
          class: 'text-right',
        },
      },
      // {
      //   displayName: 'report.winloseSimple.datatable.bonusAmount',
      //   attr: {
      //     rowspan: 2,
      //     class: 'text-right',
      //   },
      // },
      {
        displayName: 'report.winloseSimple.datatable.result',
        attr: {
          rowspan: 2,
          class: 'text-left',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.level',
        attr: {
          rowspan: 2,
          class: 'text-left',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.balance',
        attr: {
          rowspan: 2,
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.summarize',
        attr: {
          colspan: 99,
        },
        isCompanyHidden: true,
      },
    ],
    [
      {
        displayName: 'report.winloseSimple.datatable.member',
        attr: {
          class: 'text-right',
        },
      },
    ],
  ],
};
